import {defineStore} from "pinia";
import {createBaseStore} from "@/stores/base";

export const useScheduleStore = defineStore('schedule', createBaseStore('/plaene/',
        {
            currently_scheduling: false,
            currentSort: [
                {col: 'endDate', sortDir: 'desc'}
            ]
        },
        {
            async copySchedule(scheduleId) {
                const copy_string = await this.axios.get(`/plaene/${scheduleId}/besetzung/`);
                if (window.isSecureContext) {
                    await navigator.clipboard.writeText(copy_string.data.trim());
                } else { // Application is neither HTTPS nor localhost
                    console.warn('The application does not run in a secure context! This prevents access to the Clipboard API.');
                    let input = document.createElement('textarea');
                    input.textContent = copy_string.data.trim();
                    document.body.appendChild(input);
                    input.select();
                    let result = document.execCommand('copy');
                    document.body.removeChild(input);
                    if (!result) {
                        alert("Plan konnte nicht in die Zwischenablage kopiert werden! \n\n" + copy_string.data.trim());
                    }
                }
            },
            async downloadSchedule(scheduleId) {
                const url = this.axios.getUri({url: `/plaene/${scheduleId}/pdf/`});
                window.open(url);
            },
            async reschedule(schedule, preserve_current_staffing, schedule_by_staff_shortage = false) {
                try {
                    this.currently_scheduling = true;
                    await this.axios.put(`/plaene/${schedule.id}/besetzung/`, {
                        erhalte_aktuelle_aufstellung: Number(preserve_current_staffing),
                        schwierige_messen_zuerst: schedule_by_staff_shortage
                    });
                    this.currently_scheduling = false;
                } catch (e) {
                    console.log(e);
                }
            },
        },
        {}
    )
)